/* eslint-disable */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import NoData from "../svgIcons/NoData";
import Spinner from "../Spinner/Spinner";
import DailyReports from "./DailyReports";
import {
  createBillingCycleAction,
  getDailyPaymentsAction,
} from "../../actions/billingCycle";
import ProgressButton from "react-progress-button";
const DailyReportList = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("profile"));
  const { payments } = useSelector((state) => state.billingCycle);
  console.log(payments);
  const isLoading = useSelector((state) => state.product.isLoading);
  const totalCash = payments
    ?.filter((e) => e.paymentMethod == "Cash")
    .reduce((accumulator, currentItem) => {
      return accumulator + currentItem.amountPaid;
    }, 0);
  const totalCheck = payments
    ?.filter((e) => e.paymentMethod == "Check" && !e.guaranteed)
    .reduce((accumulator, currentItem) => {
      return accumulator + currentItem?.check?.totalAmount;
    }, 0);
  const totalGuaranteed = payments
    ?.filter((e) => e.paymentMethod == "Check" && e.guaranteed)
    .reduce((accumulator, currentItem) => {
      return accumulator + currentItem?.check?.totalAmount;
    }, 0);

  useEffect(() => {
    dispatch(getDailyPaymentsAction(user?.result?.name));
  }, [dispatch]);

  if (!user) {
    history.push("/login");
  }
  const handleCreateDailyReport = () => {
    const isConfirmed = window.confirm(
      "Are you sure you want to process this report?"
    );

    if (isConfirmed) {
      dispatch(
        createBillingCycleAction(
          {
            paymentIds: payments.map((payment) => payment._id),
            totalGuaranteedChecks: totalGuaranteed,
            totalChecks: totalCheck,
            totalCash: totalCash,
            assistant: user?.result?._id,
            user: user?.result?.userId[0],
          },
          history
        )
      );
    }
  };
  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "20px",
        }}
      >
        <Spinner />
      </div>
    );
  }

  if (payments?.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "20px",
          margin: "80px",
        }}
      >
        <NoData />
        <p style={{ padding: "40px", color: "gray", textAlign: "center" }}>
          No Payments yet.
        </p>
      </div>
    );
  }

  return (
    <div>
      <h1 style={{ textAlign: "center", marginTop: "2%" }}>Daily Report</h1>
      <div style={{ marginTop: "7%" }}>
        <DailyReports payments={payments} />
        <ProgressButton
          style={{
            width: "50%",
            marginLeft: "25%",
          }}
          onClick={handleCreateDailyReport}
        >
          Close
        </ProgressButton>
      </div>
    </div>
  );
};

export default DailyReportList;
